module.exports = __webpack_public_path__ + "37b7802fcf9f5bbc5b890ec7a059f247.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_header_hide_2x.png
// module id = 107
// module chunks = 0 1 2 3 4